import styled from 'styled-components';

export const SubHeader = styled.h1`
  font-weight: bold;
  font-size: 24px;
  line-height: 34px;
  color: rgba(9, 21, 38, 0.85);
`;
export const Plate = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 24px 24px 40px;
`;
export const Container = styled.div`
  padding: 56px 30px 100px 30px;
  background: #f4f5f6;
  min-height: calc(100vh - 70px);
`;
export const Header = styled.h1`
  padding-left: 24px;
  font-weight: bold;
  font-size: 30px;
  line-height: 40px;
  color: rgba(9, 21, 38, 0.85);
`;
export const Title = styled.h2`
  font-weight: bold;
  font-size: 24px;
  line-height: 34px;
`;
export const NumberElement = styled.div`
  display: inline-block;
  padding: 4px 8px 5px 8px;
  font-weight: bold;
  font-size: 30px;
  line-height: 40px;
  color: rgba(9, 21, 38, 0.85);
  border-radius: 6px;
  background: #f4f5f6;
  text-align: right;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;
export const NumberBlock = styled.div`
  width: 288px;
`;
export const Unit = styled.span`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: rgba(9, 21, 38, 0.85);
`;
export const Text = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
`;
export const FakePlate = styled.div`
  color: rgba(9, 21, 38, 0.6);
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  background: #f8f8f8;
  border-radius: 10px;
`;
